<template>
    <app-layout>
        <page-header :title="trans('profile.information.title')" title-in-app-header />
        <div class="row">
            <div class="col-md-12">
                <div class="row">
                    <div v-if="$page.props.jetstream.canUpdateProfileInformation" class="col-md-6">
                        <update-profile-information-form />
                    </div>

                    <div v-if="$page.props.jetstream.canUpdatePassword" class="col-md-6">
                        <update-password-form />
                    </div>
                </div>
                <div v-if="$page.props.jetstream.canManageTwoFactorAuthentication" id="two-factor-authentication">
                    <two-factor-authentication-form class="mt-10 sm:mt-0" />
                </div>

                <update-user-settings-form />

                <sms-notifications-form v-if="hasFeature('sms_notification')" />
                <template v-if="$page.props.jetstream.hasAccountDeletionFeatures">
                    <delete-user-form class="mt-10 sm:mt-0" />
                </template>
            </div>
        </div>
    </app-layout>
</template>

<script setup>
import AppLayout from '@/Layouts/AppLayout.vue';
import TwoFactorAuthenticationForm from '@/Pages/Profile/TwoFactorAuthenticationForm.vue';
import UpdatePasswordForm from '@/Pages/Profile/UpdatePasswordForm.vue';
import UpdateProfileInformationForm from '@/Pages/Profile/UpdateProfileInformationForm.vue';
import UpdateUserSettingsForm from '@/Pages/Profile/UpdateUserSettingsForm.vue';
import SmsNotificationsForm from '@/Pages/Profile/SmsNotificationsForm.vue';
import DeleteUserForm from '@/Pages/Profile/DeleteUserForm.vue';
import PageHeader from '@/Components/PageHeader.vue';
import { hasFeature } from '@/mixins/hasFeature.js';
import { nextTick, onMounted } from 'vue';
import { usePage } from '@inertiajs/vue3';

defineProps({
    sessions: Array,
    confirmsTwoFactorAuthentication: Boolean,
    passwordValidationMessages: Object,
    isEditable: Boolean,
});

const page = usePage();

onMounted(async () => {
    if (!page.props.requiresTwoFactor) {
        return;
    }
    await nextTick();
    const el = document.getElementById('two-factor-authentication');
    if (el) {
        const navbarHeight = 61;
        const top = el.getBoundingClientRect().top + window.scrollY - navbarHeight;
        window.scrollTo({ top, behavior: 'smooth' });
    }
});
</script>
